import { render } from "./DocumentsBySection.vue?vue&type=template&id=6373634c&scoped=true"
import script from "./DocumentsBySection.vue?vue&type=script&lang=js"
export * from "./DocumentsBySection.vue?vue&type=script&lang=js"

import "./DocumentsBySection.vue?vue&type=style&index=0&id=6373634c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6373634c"]])

export default __exports__